module.exports = __webpack_public_path__ + "media/music/punchy_bass_0-8b563e49.mp3";